export function isEnvProduction() {
  return process.env.NEXT_PUBLIC_APP_ENV === 'production'
}

export function isEnvStaging() {
  return process.env.NEXT_PUBLIC_APP_ENV === 'staging'
}

export function isEnvDevelopment() {
  return process.env.NEXT_PUBLIC_APP_ENV === 'development'
}
